function toArray(v) {
  return Array.isArray(v) ? v : [];
}

function normalizeStageDates(stage) {
  const dates = toArray(stage?.dates)
    .map((d) => ({ ...d, _t: d?.date ? new Date(d.date).getTime() : NaN }))
    .filter((d) => Number.isFinite(d._t));
  dates.sort((a, b) => a._t - b._t);
  return dates;
}

export function getStageCandidateIdSet(stage) {
  const set = new Set();
  const dates = toArray(stage?.dates);
  dates.forEach((d) => {
    toArray(d?.entered).forEach((id) => set.add(id));
    toArray(d?.approved).forEach((id) => set.add(id));
    toArray(d?.rejected).forEach((id) => set.add(id));
  });
  return set;
}

function addCandidateFirstDate(map, id, label) {
  if (!map.has(id)) map.set(id, label);
}

export function getJobCandidateFirstDateMap(job, stageName) {
  const stages = toArray(job?.stages);
  const targetStages =
    stageName == null ? stages : stages.filter((s) => s?.stage === stageName);

  const firstDateByCandidate = new Map();
  targetStages.forEach((stage) => {
    const dates = normalizeStageDates(stage);
    dates.forEach((d) => {
      const submittedDate = new Date(d.date);
      const label = submittedDate.toISOString().slice(0, 10);
      toArray(d?.entered).forEach((id) =>
        addCandidateFirstDate(firstDateByCandidate, id, label),
      );
      toArray(d?.approved).forEach((id) =>
        addCandidateFirstDate(firstDateByCandidate, id, label),
      );
      toArray(d?.rejected).forEach((id) =>
        addCandidateFirstDate(firstDateByCandidate, id, label),
      );
    });
  });

  return firstDateByCandidate;
}

export function getJobStageCandidateCount(job, stageName) {
  return getJobCandidateFirstDateMap(job, stageName).size;
}

export function getJobStageCandidateCountInRange(job, stageName, startMs, endMs) {
  const stages = toArray(job?.stages);
  const stage = stages.find((s) => s?.stage === stageName);
  const dates = toArray(stage?.dates);
  const set = new Set();

  dates.forEach((d) => {
    const t = d?.date ? new Date(d.date).getTime() : NaN;
    if (!Number.isFinite(t)) return;
    if (startMs != null && t < startMs) return;
    if (endMs != null && t > endMs) return;
    toArray(d?.entered).forEach((id) => set.add(id));
    toArray(d?.approved).forEach((id) => set.add(id));
    toArray(d?.rejected).forEach((id) => set.add(id));
  });

  return set.size;
}

export function buildStageCandidateRows(jobs, stageName) {
  const rows = [];
  const seen = new Set();

  toArray(jobs).forEach((job) => {
    const jobId = job?.jobId ?? "";
    const jobTitle = job?.jobTitle ?? "";
    const companyName = job?.companyName ?? "";

    const firstDateByCandidate = getJobCandidateFirstDateMap(job, stageName);

    const ids = Array.from(firstDateByCandidate.keys());
    ids.forEach((candidateId) => {
      const key = `${jobId}|${candidateId}`;
      if (seen.has(key)) return;
      seen.add(key);
      rows.push({
        candidateId,
        submittedDate: firstDateByCandidate.get(candidateId) || "",
        jobTitle,
        companyName,
      });
    });
  });

  rows.sort((a, b) => {
    const at = String(a.submittedDate || "");
    const bt = String(b.submittedDate || "");
    if (bt !== at) return bt.localeCompare(at);
    return String(a.candidateId || "").localeCompare(String(b.candidateId || ""));
  });
  return rows;
}

export function buildInternalSubmissionCandidateRows(jobs, stageName) {
  return buildStageCandidateRows(jobs, stageName);
}
